import { h, render, Component } from 'preact';

const renderImage = function(imageSrc) {
    if(imageSrc) {
        return (
            <div class="product-preview__image-wrapper">
                <img src={ imageSrc } class="product-preview__image" alt="" />
            </div>
        )
    }

    return null;
}

const renderCharacteristics = function(characteristics) {
    let keys = Object.keys(characteristics);
    if(keys.length) {
        return(
            <ul class="product-preview__characteristics">
                {
                    keys.map(key => {
                        return (
                            <li class="product-preview__characteristics__item">
                                <span class="product-preview__characteristics__label">
                                    { key }
                                </span>
                                <span class="product-preview__characteristics__value">
                                    { characteristics[key] }
                                </span>
                            </li>
                        )
                    })
                }
            </ul>
        )
    }
}

export default class ProductPreview extends Component {

    render(props) {
        return (
            <li class={`product-preview ${props.class}`}>
                { renderImage(props.imageSrc) }
                { 
                    props.title
                        ? <h6 class="product-preview__title">{ props.title }</h6>
                        :  null
                }
                { renderCharacteristics(props.characteristics) }
                {
                    props.url
                        ?
                            <a
                                href={props.url}
                                class="overlay-link promo-grid__item__link">
                            </a>

                        : null
                }
            </li>
        )
    }
}